import { createContext, useContext, useState } from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
const ValidationContext = /*#__PURE__*/createContext(null);
const ValidationProvider = ({
  rules = {},
  ...rest
}) => {
  const [values, setValues] = useState(rules);
  const handleRules = value => {
    setValues(prev => ({
      ...prev,
      ...value
    }));
  };
  return /*#__PURE__*/_jsx(ValidationContext.Provider, {
    value: {
      rules: values,
      setRules: handleRules
    },
    ...rest
  });
};
const useValidation = validationRuleName => {
  const context = useContext(ValidationContext);
  if (!validationRuleName) {
    return undefined;
  }
  if (context) {
    const {
      rules
    } = context;
    return rules[validationRuleName];
  }
  return undefined;
};
export { ValidationProvider, useValidation };
//# sourceMappingURL=ValidationContext.js.map